import React, { useEffect, useState } from 'react'

function fmtDate(s) {
    if (!s) return 'NA'
    try {
        // Parse YYYY-MM-DD as local midnight (timezone-safe) instead of UTC.
        const m = typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s) ? s.split('-') : null
        const d = m ? new Date(Number(m[0]), Number(m[1]) - 1, Number(m[2])) : new Date(s)
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    } catch (_e) { return s }
}

// Edit/view row for a single reminder (Invoice Due Email, Reminder 1/2/3).
// Used in step 2 inside the Payment Reminders accordion.
export default function ReminderItem({ label, value, onUpdate, isEditing, onStartEdit, onCancel }) {
    const [draft, setDraft] = useState(value || '')
    // Sync draft when parent recomputes reminders (e.g. due-date change).
    useEffect(() => { setDraft(value || '') }, [value])

    return (
        <div className="flex items-center gap-3 py-2">
            <span className="inline-flex items-center text-xs text-gray-600 border border-gray-200 rounded-full px-2.5 py-0.5">
                {label}
            </span>
            {!isEditing ? (
                <>
                    <span className="text-sm text-gray-700 flex-1">{fmtDate(value)}</span>
                    <button type="button" onClick={onStartEdit} className="text-[#115E59] hover:opacity-80" title="Edit">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M5.5 16h2.21l8.77-8.77-2.21-2.21L5.5 13.79V16zM18 5.62l-2.62-2.62-1.06 1.06 2.62 2.62L18 5.62z"/></svg>
                    </button>
                </>
            ) : (
                <div className="flex items-center gap-2 flex-1">
                    <input
                        type="date"
                        value={draft}
                        onChange={(e) => setDraft(e.target.value)}
                        className="text-sm border border-gray-300 rounded px-2 py-1"
                    />
                    <button type="button" onClick={() => onUpdate?.(draft)} className="text-xs px-3 py-1.5 text-white rounded" style={{ backgroundColor: '#115E59' }}>Save</button>
                    <button type="button" onClick={onCancel} className="text-xs px-3 py-1.5 border border-gray-300 rounded hover:bg-gray-50">Cancel</button>
                </div>
            )}
        </div>
    )
}
